<template>
  <div>
    <el-page-header class="detail-head" @back="goBack" content="模板详情"> </el-page-header>
    <el-divider></el-divider>
    <div class="detail-container">
      <el-scrollbar>
        <el-form class="detail-form" ref="mainForm" :model="entity" :rules="rules" label-width="120px">
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="编码" class="detail-form-item" prop="code">
                  <el-input size="medium" v-model="entity.code"></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="名称" class="detail-form-item" prop="name">
                  <el-input size="medium" v-model="entity.name"></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="路径" class="detail-form-item" prop="path">
                  <el-input size="medium" v-model="entity.path"></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="类型" class="detail-form-item" prop="type">
                  <el-select class="detail-form-item-select" size="medium" v-model="entity.type">
                    <el-option v-for="item in types" :key="item.itemKey" :label="item.itemValue" :value="item.itemKey">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="客户端" class="detail-form-item">
                  <el-radio-group v-model="entity.client">
                    <el-radio label="pc">电脑</el-radio>
                    <el-radio label="mobile">手机</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="关联主模板" class="detail-form-item">
                  <el-input size="medium" v-model="entity.mainTemplate.name" readonly></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="2">
              <div class="grid-content">
                <el-button type="text" size="medium" @click="selectTemplate">选择模板</el-button>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <div class="grid-content">
                <el-form-item label="内容" class="detail-form-item">
                  <el-input type="textarea" rows="20" v-model="content"></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="创建人" class="detail-form-item">
                  <el-input size="medium" v-model="entity.creator" disabled></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="创建时间" class="detail-form-item">
                  <el-input size="medium" v-model="entity.createTime" disabled></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="修改人" class="detail-form-item">
                  <el-input size="medium" v-model="entity.modifier" disabled></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="修改时间" class="detail-form-item">
                  <el-input size="medium" v-model="entity.modifyTime" disabled></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <div class="grid-content">
                <el-form-item label="备注" class="detail-form-item">
                  <el-input type="textarea" v-model="entity.remark"></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </el-scrollbar>
    </div>
    <el-divider class="detail-divider"></el-divider>
    <div class="detail-form-item-btns">
      <el-button v-if="edit" size="medium" class="detail-form-item-btn" type="primary" @click="save">保存</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="goBack">返回列表</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="reset">刷新</el-button>
    </div>
  </div>
  <TemplateRefer ref="templateRefer"> </TemplateRefer>
</template>

<script lang="ts">
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import { Template } from "@/script/apps/cms/entity/CmsEntity";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { TagService } from "@/script/apps/cms/service/TagService";
import { ElMessage } from "element-plus";
import { TemplateService } from "@/script/apps/cms/service/TemplateService";
import TemplateRefer from "./TemplateRefer.vue";

@Options({
  components: { TemplateRefer },
})
export default class TemplateDetail extends BaseDetail {
  private service = new TemplateService();
  private content = "";

  public initData(): ServiceContext {
    const data = ServiceFactory.build(
      "biz_cms_template",
      "/cms/template",
      "/cms/template",
      this.service
    );
    data.typesName = "template-type";
    return data;
  }

  private rules = {
    code: [{ required: true, message: "请输入编码", trigger: "blur" }],
    name: [{ required: true, message: "请输入名称", trigger: "blur" }],
    path: [{ required: true, message: "请输入路径", trigger: "blur" }],
    type: [{ required: true, message: "请选择类型", trigger: "change" }],
  };

  public newEntity() {
    const entity: Template = { mainTemplate: { name: "" } };
    this.content = "";
    return entity;
  }

  public afterLoad(data: any) {
    const template = data as Template;
    this.content = "";
    this.service.loadContent(template.id!).then(
      (result: any) => {
        this.content = result.data;
      },
      (error: Error) => {        
        ElMessage.error("读取内容失败，失败原因：" + error.message);
      }
    );

    if (!template.mainTemplate) {
      template.mainTemplate = { name: "" };
    }
    if (template.mainTemplateId) {
      this.serviceContext.service.loadEntity(
        this.serviceContext.serviceData.loadApiName,
        {
          id: template.mainTemplateId!,
        },
        (data: any) => {
          template.mainTemplate = data;
        }
      );
    }
  }

  private selectTemplate() {
    (this.$refs.templateRefer as TemplateRefer).show((data: Template) => {
      const template = this.entity as Template;
      template.mainTemplateId = data.id;
      template.mainTemplate!.name = data.name;
    });
  }

  public save() {
    const self = this;
    (this.$refs.mainForm as any).validate((valid: boolean) => {
      if (valid) {
        if (!self.beforeSave()) {
          return;
        }
        self.serviceContext.service.saveEntity(
          self.serviceContext.serviceData.saveApiName,
          self.entity,
          function (data: any) {
            self.id = data.id;
            self.entity.id = data.id;
            ElMessage({ type: "success", message: "保存成功!" });

            self.service.saveContent(self.entity.id!, self.content).then(
              (result: any) => {
                self.load(self.id);
              },
              (error: Error) => {
                ElMessage.error("保存内容失败，失败原因：" + error.message);
              }
            );
          },
          function (error: Error) {
            ElMessage.error("保存失败，原因：" + error.message);
          }
        );
      } else {
        return false;
      }
    });
  }
}
</script>

<style lang="scss">
</style>
